var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipFileFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 17.943,
    viewBox: "0 0 24 24",
    width: 18.597,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "zip-file-format") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 11.5h-.5v1h.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.25 5h-10.939l-1.781-1.78c-.14-.141-.331-.22-.53-.22h-5.25c-1.517 0-2.75 1.233-2.75 2.75v12.5c0 1.517 1.233 2.75 2.75 2.75h18.5c1.517 0 2.75-1.233 2.75-2.75v-10.5c0-1.517-1.233-2.75-2.75-2.75zm-13 9.5c.414 0 .75.336.75.75s-.336.75-.75.75h-2.5c-.266 0-.512-.141-.646-.37-.135-.229-.139-.512-.009-.744l1.881-3.386h-1.226c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.266 0 .512.141.646.37.135.229.139.512.009.744l-1.881 3.386zm4 .75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75zm3.75-1.25h-.5v1.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75h1.25c1.103 0 2 .897 2 2s-.897 2-2 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipFileFormat);
export default __webpack_public_path__ + "static/media/zip-file-format.a674ef107a20ae68092333447b9761d7.svg";
export { ForwardRef as ReactComponent };